import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import DemoLanguageSwitch from './DemoLanguageSwitch';
import { BD } from '../bookDemoTheme';

interface DemoHeaderProps {
  onClose: () => void;
}

const DemoHeader: React.FC<DemoHeaderProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <header
      className={`sticky top-0 z-40 flex items-center justify-between py-[18px] px-4 sm:px-6 lg:px-12 mb-8 sm:mb-10 ${BD.headerBg} ${BD.headerRing}`}
    >
      {/* The logo is the exit users reach for first, so it leaves the same way the X does. */}
      <button
        type="button"
        onClick={onClose}
        aria-label={t('bookDemo.backToHome')}
      >
        <img src="/assets/logo.svg" width="181" height="44" alt="Culinary Cloud" />
      </button>
      <div className="flex items-center gap-2 sm:gap-3">
        <DemoLanguageSwitch />
        <button
          type="button"
          onClick={onClose}
          aria-label={t('bookDemo.close')}
          className={`w-10 h-10 rounded-lg border flex items-center justify-center transition-colors ${BD.ghostButton}`}
        >
          <X size={20} strokeWidth={1.67} />
        </button>
      </div>
    </header>
  );
};

export default DemoHeader;
